import BaseAtomView from 'views/atoms/base-atom-view';
import ControlBarMenuTemplate from './templates/control-bar-menu-atom';
import IconLoadService from 'services/loader-handler-services/icon-load-service';
import $ from 'jquery';
import { KeybindingService, keys } from 'services/event-handler-services/keybinding-service';

const { Enter, ArrowDown, ArrowUp, ArrowLeft, ArrowRight } = keys;

const ControlBarMenuAtomView = BaseAtomView.extend({
  template: ControlBarMenuTemplate,
  initialize: function () {
    BaseAtomView.prototype.render.apply(this, arguments);
    this.subscribeEvent('tippy:show', this.applyIcons);
  },
  applyIcons: function () {
    if (Array.isArray(this.model.get('items'))) {
      this.model.get('items').forEach((item, index) => {
        if (item.before_icon) {
          IconLoadService.applyIcon(
            item.before_icon.icon,
            `${this.model.get('cid')}-${this.model.get('key')}-${index}-before-icon`
          );
        }
        if (item.after_icon) {
          IconLoadService.applyIcon(
            item.after_icon.icon,
            `${this.model.get('cid')}-${this.model.get('key')}-${index}-after-icon`
          );
        }
      });
    }
    if (this.model.get('submenu')) {
      IconLoadService.applyIcon(
        'fas fa-chevron-circle-left',
        `${this.model.get('cid')}-${this.model.get('key')}-back-icon`
      );
    }
  },
 onBackButtonClick() {
    const parentMenuKey = this.model.get('backButtonTarget');
    $(`.control-bar-menu-${parentMenuKey}`).show();
    this.$el.find(`.control-bar-menu-${this.model.get('key')}`).hide();
    $(`.control-bar-menu-${parentMenuKey} [aria-expanded]`).attr('aria-expanded', 'false');
    $(`.control-bar-menu-${parentMenuKey} a`).trigger('focus');
  },
  render: function () {
    BaseAtomView.prototype.render.apply(this, arguments);
    if (this.model.has('backButtonTarget')) {
      this.$el.find('.control-bar-menu__back-button').on('click', this.onBackButtonClick.bind(this));
    }
    if (Array.isArray(this.model.get('items'))) {
      this.model.get('items').forEach((item, index) => {
        if (item.target) {
          this.$el.find(`.control-bar-menu-${item.targetMenuKey}`).hide();
          this.delegate('click', `[data-target="${item.target}"]`, function () {
            this.$el.find(`.control-bar-menu-${this.model.get('key')}`).hide();
            this.$el.find(`[data-target="${item.target}"]`).attr('aria-expanded', 'true');
            this.$el.find(`.control-bar-menu-${item.targetMenuKey}`).show();
            this.$el.find(`.control-bar-menu-${item.targetMenuKey} li a`).first().focus();
          });
        }
        if (item.modalID) {
          const selector = `[data-open-modal="${item.modalID}"]`
          this.delegate('click keydown', selector, function (e) {
            if (e.type === 'keydown' && !(e.key === 'Enter' || e.key === ' ')) {
              return;
            }
            e.preventDefault();
            e.stopPropagation();
            this.publishEvent('button:clicked:#course-settings-modal', {
              target: '#course-settings-modal',
              action: 'open_modal',
            });
          });
        }
        this.delegate('keydown', `.control-bar-menu-${this.model.get('key')}`, function (evt) {
          const elements = this.$el.find(`.control-bar-menu-${this.model.get('key')} li a`);
          const firstFocusableEl = elements[0];
          const lastFocusableEl = elements[elements.length - 1];
          KeybindingService.with(evt).bind(
            Enter,
            () => {
              evt.target.click();
            },
            [ArrowDown, ArrowRight],
            () => {
              evt.preventDefault();
              const nextEl = $(evt.target).parent().next().find('a');
              if (nextEl) {
                nextEl.trigger('focus');
              } else {
                firstFocusableEl.focus();
              }
            },
            [ArrowUp, ArrowLeft],
            () => {
              evt.preventDefault();
              const prevEl = $(evt.target).parent().prev().find('a');
              if (prevEl) {
                prevEl.trigger('focus');
              } else {
                lastFocusableEl.focus();
              }
            }
          );
        });

        if (item.onClick && item.key) {
          if (item['ariaLabel']) {
            this.$el.find(`.control-bar-menu__item-${index}`).attr('aria-label', item['ariaLabel']);
          }
          const onClick = function () {
            if (this.model.get('hideInactiveBeforeIcons')) {
              const el = this.$el.find('.control-bar-menu__item');
              el.removeClass('control-bar-menu__item--active');
              el.attr('aria-checked', 'false');
              this.model.get('items').forEach(a => (a.active = false));
              this.$el.find('.control-bar-menu__item').attr('aria-checked', false);
              item.active = true;
              const activeEl = this.$el.find(`.control-bar-menu__item-${index}`);
              activeEl.addClass('control-bar-menu__item--active');
              activeEl.attr('aria-checked', 'true');
            }
            item.onClick();
          };

          this.delegate('click', `[data-key="${this.model.get('key')}-${this.model.get('cid')}-${item.key}"]`, onClick);
        }
      });
    }
  },
});

export default ControlBarMenuAtomView;
